import {
  Stack,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Menu } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';

interface Props {
  toggleMenu: () => void;
}

const MainButtons: React.FC<Props> = ({ toggleMenu }) => {
  const user = useSelector((state: RootState) => state.auth.user);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Stack
      direction="row"
      flex={1}
      justifyContent="space-between"
      alignItems="center"
      mr={2}
    >
      <Stack direction="row" alignItems="center" spacing={1}>
        {isMobile && (
          <IconButton onClick={toggleMenu} aria-label="Open menu">
            <Menu htmlColor="#fff" />
          </IconButton>
        )}
        <Link to="/" style={{ textDecoration: 'none' }}>
          <Typography variant="h6" fontWeight={700} color="#fff">
            DealerScout
          </Typography>
        </Link>
      </Stack>
      {user && !isMobile && (
        <Typography variant="body2" color="#fff">
          {user.firstName} {user.lastName}
        </Typography>
      )}
    </Stack>
  );
};

export default MainButtons;
